export default __webpack_public_path__ + "static/media/upon_my_death_do_this.c1941818.pdf";